import React from 'react';
import clsx from 'clsx';

import styles from './StatusMarker.module.scss';
import infoIcon from 'assets/images/font-icons/info-24px.svg'

export type StatusMarkerProps = {
  className?: string;
  id?: string;
  showInfoIcon?: boolean
};

export const StatusMarker: React.FC<StatusMarkerProps> = ({ className, children, showInfoIcon, ...props }) => (
  <div className={clsx(styles.root, className)} {...props}>
    {children}
    {showInfoIcon && <img src={infoIcon} className='ml-2' width='20' />}
  </div>
);
